import { isCampaignClosed } from './fundStore.js';

export function renderMyCampaignsModal(campaigns, fund) {
    if (!campaigns.length) {
        return `<p class="fg-fund-empty-sub">${fund.tr('noMyCampaigns')}</p>`;
    }
    const cards = campaigns.map((p) => {
        const pct = p.target ? Math.min(Math.round((p.raised / p.target) * 100), 100) : 0;
        const hero = p.imageURL || p.images?.[0] || '';
        const status = p.status === 'live' && !isCampaignClosed(p)
            ? fund.tr('statusLive')
            : (p.status === 'draft' ? fund.tr('statusDraft') : fund.tr('closed'));
        return `
            <article class="fg-fund-my-campaign-card" data-campaign-id="${p.id}">
                <div class="fg-fund-my-campaign-card__img" style="${hero ? `background-image:url('${hero.replace(/'/g, '%27')}')` : ''}" role="img" aria-label="${p.title}"></div>
                <div class="fg-fund-my-campaign-card__body">
                    <span class="fg-fund-my-campaign-card__status">${status}</span>
                    <h4>${p.title}</h4>
                    <p>€${(p.raised || 0).toLocaleString()} / €${(p.target || 0).toLocaleString()}</p>
                    <div class="fg-fund-card__progress-bar"><div class="fg-fund-card__progress-fill" style="width:${pct}%"></div></div>
                    <button type="button" class="fg-fund-btn fg-fund-btn--ghost" data-open-campaign="${p.id}">${fund.tr('manageCampaign')}</button>
                </div>
            </article>`;
    }).join('');

    return `
        <div class="fg-fund-my-campaigns-deck" role="list">${cards}</div>`;
}
